import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { createColumnHelper } from '@tanstack/react-table'

import Table, { TableProps } from '@/components/ui/tables/Table'

export type PolicyData = {
  id: string
  name: string
  description?: string
}

export type PolicySelectionTableProps = Pick<TableProps<PolicyData>, 'data' | 'onSelectRow' | 'selectedRows' | 'selectable'>

const columnHelper = createColumnHelper<PolicyData>()

export function PolicySelectionTable(props: PolicySelectionTableProps) {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: t('table.policySelection.header.name').toString(),
      }),
      columnHelper.accessor('description', {
        header: t('table.policySelection.header.description').toString(),
      }),
    ],
    [t]
  )

  return <Table {...props} container="div" columns={columns} />
}

export default PolicySelectionTable
